const getUsers = (state) => state.admin.users;
const getController = (state) => state.admin.controller;
const getUserController = (state) => state.admin.ota;
const getInvoice = (state) => state.admin.invoice;

const selectors = {
  getUsers,
  getController,
  getUserController,
  getInvoice,
};

export default selectors;
